<template>
  <div v-if="showModal2" class="modal">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <div class="icon-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon animated-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18A2 2 0 003.63 21h16.74a2 2 0 001.81-3L13.71 3.86a2 2 0 00-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12" y2="17"></line>
        </svg>
      </div>
      <h2>PERMISO DENEGADO</h2>
      <p>No tienes permisos para realizar esta acción. Si necesitas acceso, contacta al administrador.</p>
      
      <div style="text-align: center; margin-top: 20px;">
        <button @click="closeModal" class="btn-close-modal">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  showModal2: {
    type: Boolean,
    required: true,
  }
});

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
};
</script>

<style scoped>
.modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 1000 !important;
  transition: opacity 0.3s ease-in-out !important;
}

.modal-content {
  background: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  width: 500px !important;
  max-width: 90%;
  animation: fadeIn 0.4s ease;
  text-align: center;
  position: relative;
}

.close {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 25px;
  font-weight: bold;
  color: #555;
  cursor: pointer;
  transition: color 0.2s;
}

.close:hover {
  color: #f44336;
}

.icon-wrapper {
  margin: 0 auto 20px auto;
}

.icon {
  width: 60px;
  height: 60px;
  color: #f44336;
}

.icon-wrapper {
  margin-bottom: 20px;
}

.animated-icon {
  animation: shake 0.8s ease-in-out infinite;
  animation-delay: 0.7s;
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  20%, 60% {
    transform: translateX(-5px);
  }
  40%, 80% {
    transform: translateX(5px);
  }
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #000000;
  font-size: 1.8rem;
  font-weight: 600;
  border-bottom: 2px solid #ddd;
  padding-bottom: 10px;
}

p {
  text-align: center;
  font-size: 1rem;
  color: #555;
}

.btn-close-modal {
  background-color: #555;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.btn-close-modal:hover {
  background-color: #9358ff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
